import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import pako from 'pako';
import {EtatCompressionWebservicesService} from './etat-compression-webservices.service';

/**
 * Interceptor utilisé pour compresser les requêtes POST et PUT.
 */
@Injectable()
export class CompressionInterceptor implements HttpInterceptor {

	constructor(private etatCompressionWebservicesService: EtatCompressionWebservicesService) {
	}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
		// On compresse les requêtes POST ou PUT si le body a une taille plus grande que 10ko.
		if (!request.url.includes('ws/auth') &&
				['POST', 'PUT'].includes(request.method) &&
				this.etatCompressionWebservicesService.compressionActivee &&
				new Blob([JSON.stringify(request.body)]).size > 10000) {
			const gzippedObject = pako.gzip(JSON.stringify(request.body)).buffer;

			request = request.clone({
				headers: request.headers
					.append('Content-Encoding', 'gzip')
					.set('Content-Type', 'application/json'),
				body: gzippedObject
			});
		}

		return next.handle(request);
	}
}
